module.exports = __webpack_public_path__ + "a2a5d110cd8508b9cc634e82f70bbe8d.png";